<template>
     <div class="submit-giveaway-box mt-4 | grid grid-cols-1 | 2xl:gap-4 2xl:grid-cols-3 | ">
        <div v-if="give_away_box_image" class="col-span-2">
            <img :src="give_away_box_image" alt="Give way image"/>
        </div>
        <div v-if="give_away_box_text" v-html="give_away_box_text" class="submit-giveaway-box_text p-2 |  xl:py-4 xl:pl-2 xl:pr-4"></div>
    </div>
</template>
<style lang="scss">
.submit-giveaway-box{
    @apply border-dashed border-2 border-primary-light;

    &_text{
        p{
            @apply text-sm leading-5;
        }
        ul,ol{
            list-style: auto;
            margin-left: 1em;
            li{
                @apply text-sm leading-5;
            }
        }
    }
}
</style>
<script>
import { useStore } from 'vuex'
import {computed} from 'vue'

export default {
    name: "GiveAwayBox",
    components:{

    },
    data() {
        return {

        }
    },
    mounted() {

    },
    setup(props){
        const store = useStore()

        return {
            submitButtonComment: computed(() => store.state.quizData.submit_page.text_below_submit_button),
            display_give_away_box: computed(() => store.state.quizData.submit_page.display_give_away_box),
            give_away_box_image: computed(() => store.state.quizData.submit_page.give_away_box_image),
            give_away_box_text: computed(() => store.state.quizData.submit_page.give_away_box_text),
        }
    },
    methods:{

    },
    props: {

    }
}
</script>
